import {
  createAsyncThunk,
  createSlice,
  Draft,
  PayloadAction
} from "@reduxjs/toolkit";
import * as ClientService from "./../../services/ClientService";
import { HttpCodes } from "../../constants/app.constant";

export interface State {
  clientsList: any[];
  isClientsLoading: boolean;
  selectedClient: any;
}

const initialState: State = {
  clientsList: [],
  isClientsLoading: false,
  selectedClient: {}
};

export const clientSearchThunk = createAsyncThunk(
  "clients/clientSearchThunk",
  async (thunkApi: any) => {
    try {
      const response = await ClientService.clientsSearch();
      if (response.responseCode == HttpCodes.SUCCESS) {
        return response.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);

      return thunkApi.rejectWithValue(e);
    }
  }
);

export const clientSelectionSlice = createSlice({
  name: "clientSelection",
  initialState,
  reducers: {
    resetStateClient: (state: Draft<State>) => {
      return { ...state, clientsList: [], isClientsLoading: false };
    },
    setSelectedClient: (state: Draft<any>, action: PayloadAction) => {
      state.selectedClient = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(clientSearchThunk.pending, (state, action) => {
      state.isClientsLoading = true;
    });
    builder.addCase(clientSearchThunk.fulfilled, (state, action) => {
      state.clientsList = action.payload;
      state.isClientsLoading = false;
    });
    builder.addCase(clientSearchThunk.rejected, (state, action) => {
      state.isClientsLoading = false;
      state.clientsList = [];
    });
  }
});

export const { setSelectedClient, resetStateClient } =
  clientSelectionSlice.actions;

export default clientSelectionSlice.reducer;
